import React, { memo } from 'react'

import { VideocamOffOutlined, VideocamOutlined } from '@material-ui/icons'

import useUserCamera from '@tabeeb/modules/presentation/hooks/useUserCamera'
import { ToggleCamera } from '@tabeeb/shared/constants/keyboardShortcuts'
import ShortcutTooltip from '@tabeeb/uikit/components/ShortcutTooltip'
import { VideoCallUser } from '@tabeeb/modules/../users/types'
import ToolbarButton from '../ToolbarButton'

interface MuteUserCameraToolbarButtonProps {
  user: VideoCallUser
}

const MuteUserCameraToolbarButton: React.FC<MuteUserCameraToolbarButtonProps> = ({ user }) => {
  const { isMuted, selectedCallUser, currentUserId, handleClick } = useUserCamera({ user })

  return (
    <ShortcutTooltip
      title={isMuted ? 'Unmute camera' : 'Mute camera'}
      keys={selectedCallUser?.id === currentUserId ? ToggleCamera : []}
    >
      <ToolbarButton Icon={isMuted ? VideocamOffOutlined : VideocamOutlined} onClick={handleClick} />
    </ShortcutTooltip>
  )
}

export default memo(MuteUserCameraToolbarButton)
